import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import BasicDatePicker from '../../../../components/Datepicker/Datepicker';
import Input from '../../../../components/Inputs/Input';
import './ThreshInterval.css';


export const ThreshInterval = ({ part, timeControl, disabled, values, onChange }) => {
    return (values &&
        <>
            <div style={{position: 'absolute'}}>
            {/* {JSON.stringify(values)} */}

            </div>
            <div className='threshinterval-component'>
                <b className='row-header'>Threshold</b>
                <b>Hours</b>
                <Input onChange={(e) => onChange({ name: 'threshHours', value: e.target.value })} disabled={disabled} isNumeric value={values.threshHours} />
                <b>Cycles</b>
                <Input onChange={(e) => onChange({ name: 'threshCycles', value: e.target.value })} disabled={disabled} isNumeric value={values.threshCycles} />
                <b>Days</b>
                <Input onChange={(e) => onChange({ name: 'threshDays', value: e.target.value })} disabled={disabled} isNumeric value={values.threshDays} />
                <b>Total Hours</b>
                <Input onChange={(e) => onChange({ name: 'totalHours', value: e.target.value })} disabled={disabled} isNumeric value={values.totalHours} />
                <b>Total Cycles</b>
                <Input onChange={(e) => onChange({ name: 'totalCycles', value: e.target.value })} disabled={disabled} isNumeric value={values.totalCycles} />
                <b>Total Days</b>
                <Input onChange={(e) => onChange({ name: 'totalDays', value: e.target.value })} disabled={disabled} isNumeric value={values.totalDays} />
                <b>Schedule Date</b>
                <BasicDatePicker disabled={disabled}
                    style={{ gridColumn: "span 1" }}
                    onChange={(newValue) => {
                        onChange({name: "threshSchedule", value: newValue?.format("YYYY-MM-DD") || ""})
                    }}
                    value={values.threshSchedule}

                    isDateTime={false}
                ></BasicDatePicker>
                <CheckboxField onChange={(e) => onChange({ name: 'threshLatest', value: e })} disabled={disabled} checked={values.threshLatest}>Latest</CheckboxField>
                <hr></hr>
                <b className='row-header'>Interval</b>
                <b>Hours</b>
                <Input onChange={(e) => onChange({ name: 'intervalHours', value: e.target.value })} disabled={disabled} isNumeric value={values.intervalHours} />
                <b>Cycles</b>
                <Input onChange={(e) => onChange({ name: 'intervalCycles', value: e.target.value })} disabled={disabled} isNumeric value={values.intervalCycles} />
                <b>Days</b>
                <Input onChange={(e) => onChange({ name: 'intervalDays', value: e.target.value })} disabled={disabled} isNumeric value={values.intervalDays} />
                <b></b>
                <b></b>
                <b></b>
                <b></b>
                <b></b>
                <b></b>
                <b>Schedule Date</b>
                <BasicDatePicker
                    style={{ gridColumn: "span 1" }}
                    onChange={(newValue) => {
                        onChange({name: "intervalSchedule", value: newValue?.format("YYYY-MM-DD") || ""})
                    }}
                    disabled={disabled}
                    value={values.intervalSchedule}
                    isDateTime={false}
                ></BasicDatePicker>
                <CheckboxField onChange={(e) => onChange({ name: 'intervalLatest', value: e })} disabled={disabled} checked={values.intervalLatest}>Latest</CheckboxField>
            </div>
        </>
    )

}